import styled from "@emotion/styled";

export const FormColumn = styled.div({
  display: "flex",
  minWidth: "0",
  flexDirection: "column",
  gap: "15px",
});
